// Canonical environment names shared across the API runtime and frontends.
// Kept dependency-free so it is safe to import from any package.
//
// NOTE: `scripts/` and `cdk/` currently live in a separate module-resolution
// domain (they cannot resolve the `@common` alias) and still declare their own
// environment unions. Wire them up to these constants once their tsconfig/path
// resolution is enabled.

/**
 * Environments the API/runtime can boot into. `local` is dev-only (there is no
 * deployed `local` environment); the rest map to deployed targets.
 */
export const API_ENVIRONMENTS = ['local', 'dev', 'staging', 'prod', 'vbatest'] as const;

export type ApiEnvironment = (typeof API_ENVIRONMENTS)[number];

/**
 * Deployable environments accepted by the CDK stacks and deploy scripts.
 * `local` is not a deploy target.
 */
export const DEPLOY_ENVIRONMENTS = ['dev', 'staging', 'prod', 'vbatest'] as const;

export type DeployEnvironment = (typeof DEPLOY_ENVIRONMENTS)[number];
